import React from 'react';

import { Button, Flex, Loader, Stack } from '@grubhubprod/gh-cookbook-react';

export interface ZipFetchingStateButtonProps {
  onClick: () => void;
}

export function ZipFetchingStateButton({
  onClick,
}: ZipFetchingStateButtonProps): JSX.Element {
  return (
    <Button
      block
      aria-label="FETCHING"
      variant="secondary"
      buttonSize="medium"
      onClick={onClick}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        className="ellipsisOverflow"
      >
        <Stack x="xx-sm">Downloading</Stack>
        <Loader size="sm" />
      </Flex>
    </Button>
  );
}
